module.exports = __webpack_public_path__ + "img/emoji_07.3f8f8dbe.png";